import React from 'react';
import BannerSlider from './bannerslider.js';
import { Router, Route, Link, browserHistory } from 'react-router'

module.exports = React.createClass({
    self: this,

    success: function(reply) {
        if (!this.mountState)
            return;
        if (reply && reply.status == 200)
            this.dueCount = window.HC_DueCount = reply.data.count;
        else
            window.HC_DueCount = undefined;
        this.forceUpdate();
    },

    error: function() {
        if (!this.mountState)
            return;
        window.HC_DueCount = undefined;
        this.forceUpdate();
    },

    getInitialState: function () {
        return {
            banners: [
                <a className="a-banner" key="1" href="http://www.xxlhoreca.com/nl/" target="_blank"><img src="/public/images/b_img1.jpg" className="li-banner" /></a>,
                <a className="a-banner" key="2" href="http://www.xxlhoreca.com/nl/" target="_blank"><img src="/public/images/b_img2.jpg" className="li-banner" /></a>,
                <a className="a-banner" key="3" href="http://www.xxlhoreca.com/nl/" target="_blank"><img src="/public/images/b_img3.jpg" className="li-banner" /></a>
            ]
        };
    },

    loadFromServer: function() {

        var session = HC_GetSession();
        var due = HC_AccInput();
        if (!session || !due)
            return;

        var request = {"session_id" : session, command:'due_count'};

        $.ajax({
            contentType: 'application/json',
            url: window.HC_SERVER ? window.HC_SERVER + "/api" : '/api',
            dataType: 'json',
            type: 'POST',
            processData: false,
            data: JSON.stringify(request),
            success: this.success,
            error: this.error
        });
    },

    checkDueCount: function() {
        if (typeof(window.HC_DueCount) !== 'undefined' && window.HC_DueCount != this.dueCount) {
            this.dueCount = window.HC_DueCount;
            this.forceUpdate();
        }
    },

    componentDidMount: function() {
        this.mountState = true;
        this.loadFromServer();
        setInterval(this.checkDueCount, 500);
        setInterval(this.loadFromServer, HC_DUE_INTERVAL);
    },

    componentWillUnmount: function() {
        this.mountState = false;
    },

    renderSingupPage: () => {
        const isSA = HC_GetBoolSetting('HC_SA');
        if (!isSA) return null;

        return (
            <li id="li-register-new-accounts" onClick={HC_RestoreNavPanel}>
                <Link to="/register-new-accounts" style={{display:'block', paddingLeft:'10%'}}>
                    <span className="faspan">
                        <div className="fadiv">
                            <i className="fa fa-user hc-fa-small" />
                        </div>
                    </span>
                    <span className="hc-f4 faspan">Register Accounts</span>
                </Link>
            </li>
        );
    },

    render: function() {
        var due, checklists, documents, reports, users;

        if (HC_NeedHideNavPanel())
            return null;

        if (HC_GetBoolSetting("HC_IsSubscribed")) {
            if (HC_AccInput()) {
                var bgColor;
                if (typeof(window.HC_DueCount) !== 'undefined') {
                    bgColor = '#30ae97';
                    this.dueCount = window.HC_DueCount;
                } else {
                    this.dueCount = '--';
                    bgColor = '#8a8d91';
                }

                due = (<li id="li-due" onClick={HC_RestoreNavPanel}><Link to="/due"
                                                                          style={{display:'block', paddingLeft:'10%', paddingRight:'5%'}}><span
                    className="faspan"><div className="fadiv"><i className="fa fa-bolt hc-fa-small"></i></div></span>
                    <span className="hc-f4 faspan">{HC_LANG.NAV_DUE}</span>
                    <span className="faspan">
                        <div className="badge"
                             style={{marginLeft: '10px', display: 'block', backgroundColor: bgColor, minWidth:'1.9rem', marginBottom:'10%'}}>{this.dueCount}</div>
                    </span></Link>
                </li>);
            }

            if (HC_AccReports())
                reports = (<li id="li-reports" onClick={HC_RestoreNavPanel}><Link to="/reports"
                                                                                  style={{display:'block', paddingLeft:'10%'}}><span
                    className="faspan"><div className="fadiv"><i className="fa fa-pie-chart hc-fa-small"></i>
                </div></span><span className="hc-f4 faspan">{HC_LANG.NAV_REPORTS}</span></Link></li>);

            if (HC_AccAdmin()) {
                checklists = (<li id="li-checklists" onClick={HC_RestoreNavPanel}><Link to="/checklists"
                                                                                        style={{display:'block', paddingLeft:'10%'}}><span
                    className="faspan"><div className="fadiv"><i className="fa fa-list-ul hc-fa-small"></i>
                </div></span><span className="hc-f4 faspan">{HC_LANG.NAV_CHECKLISTS}</span></Link></li>);
                documents = (<li id="li-documents" onClick={HC_RestoreNavPanel}><Link to="/documents"
                                                                                      style={{display:'block', paddingLeft:'10%'}}><span
                    className="faspan"><div className="fadiv"><i className="fa fa-file-o hc-fa-small"></i>
                </div></span><span
                    className="hc-f4 faspan">{HC_LANG.NAV_DOCUMENTS}</span></Link></li>);
                users = (<li id="li-administrate" onClick={HC_RestoreNavPanel}><Link to="/users"
                                                                                     style={{display:'block', paddingLeft:'10%'}}><span
                    className="faspan"><div className="fadiv"><i className="fa fa-eye hc-fa-small"></i>
                </div></span><span
                    className="hc-f4 faspan">{HC_LANG.NAV_ADMIN}</span></Link></li>);
            }

            var isFeedbackUser = HC_GetBoolSetting('HC_SA');
            var feedback1 = (<li id="li-feedback" onClick={HC_RestoreNavPanel}><
                Link to={isFeedbackUser ? "/view_feedback" : "/feedback"} style={{display:'block', paddingLeft:'10%'}}>
            <span className="faspan"><div className="fadiv"><i className="fa fa-bell hc-fa-small"></i>
            </div></span><span className="hc-f4 faspan">{HC_LANG.NAV_FEEDBACK}</span></Link></li>);

            var payments, accounts;
            if (isFeedbackUser) {
                // payments = (<li id="li-payments" onClick={HC_RestoreNavPanel}><
                //     Link to="/payment_plans" style={{display:'block', paddingLeft:'10%'}}>
                //     <span className="faspan"><div className="fadiv"><i className="fa fa-bell hc-fa-small"></i>
                // </div></span><span className="hc-f4 faspan">Plans</span></Link></li>);

                accounts = (<li id="li-accounts" onClick={HC_RestoreNavPanel}>
                <Link to="/accounts" style={{display:'block', paddingLeft:'10%'}}>
                    <span className="faspan"><div className="fadiv"><i className="fa fa-bell hc-fa-small"></i>
                    </div></span><span className="hc-f4 faspan">Accounts</span></Link></li>);
            }

            var feedback0;
            if (isFeedbackUser) {
                feedback0 = feedback1;
                feedback1 = null;
            }
        }

        let banner;
        if (!window.cordova && window.HC_SITE_LOGO.isFree)
            banner = (<div className="hc-bn"> <BannerSlider data={this.state.banners}/> </div>);

        const logoStyle={marginTop:"10px", backgroundSize:"122px,40px", outline:'none', height: '40px'};

        return (
            <div className="hc-br" id="nav-panel" >

                <div align='center' style={{height: "60px", textAlign:'center'}}>
                    <Link to="/">
                        <img src={window.HC_SITE_LOGO.src} alt="logo" style={logoStyle} />
                    </Link>
                </div>
                <ul className="nav-list" style={{listStyleType:"none"}}>
                {feedback0}
                {payments}
                {accounts}
                {due}
                {checklists}
                {documents}
                {reports}
                {users}
                {this.renderSingupPage()}
                    <li id="li-profile" onClick={HC_RestoreNavPanel}><Link to="/profile"
                                                                           style={{display:'block', paddingLeft:'10%'}}><span
                        className="faspan"><div className="fadiv"><i className="fa fa-user hc-fa-small"></i>
                    </div></span><span className="hc-f4 faspan">{HC_LANG.NAV_PROFILE}</span></Link></li>
                {banner}
            </ul>
            <ul className="nav-list" style={{listStyleType:'none',position:'absolute',bottom:0}}>
                {feedback1}
                <li id="li-logout" onClick={HC_Logout}>
                    <div style={{paddingLeft:'10%'}}><span className="faspan"><div className="fadiv"><i
                        className="fa fa-sign-out hc-fa-small"></i></div></span><span
                        className="hc-f4 faspan">{HC_LANG.NAV_LOGOUT}</span></div>
                </li>
            </ul>

            </div>
        );
    },

});


// WEBPACK FOOTER //
// ./navpanel.js